import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { store } from '../store';
import { authorize } from '../features/login/loginSlice';
import Loader from '../components/Loader';
import Register from '../components/Auth/Register';
import Pending from '../components/Auth/Pending';

export default function Auth() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const [showPending, setShowPending] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const [creationUrl, setCreationUrl] = useState('');
  const [editionUrl, setEditionUrl] = useState('');

  const [loading, setLoading] = useState(true);

  const [currentEmail, setCurrentEmail] = useState('');

  const token = params.get('token');
  if (!token) {
    return <Navigate to="/login" />;
  }

  useEffect(() => {
    store.dispatch(authorize(token))
      .unwrap()
      .then(response => {
        if (typeof response !== 'object' || !response.message) {
          throw new Error('Error desconocido durante la autenticación');
        }

        // Si el login fue exitoso redirigimos al home
        if (response.message === 'USER_AUTHORIZED') {
          navigate('/');
          return;
        }

        // Si el login fue válido pero no existe el usuario nos devuelve una url
        // para cargar los datos que falta
        if (response.message === 'USER_NOT_REGISTERED') {
          setCreationUrl(response.create);
          setShowRegister(true);
          setLoading(false);
          return;
        }

        // Si el login fue válido pero el email no está validado podemos
        // reintentar o camnbiar la dirección
        if (response.message === 'MUST_VERIFY_EMAIL') {
          setEditionUrl(response.edit);
          setCurrentEmail(response.user.email);
          setShowPending(true);
          setLoading(false);
          return;
        }
      })
      .catch(err => {
        const status = store.getState();
        console.error(status.login, err);
        navigate('/');
      });
  }, []);


  return (
    <>
      <Loader loading={ loading } />;
      {
        showPending
          ? <Pending token={ token } editionUrl={ editionUrl } email={ currentEmail } />
          : null
      }
      {
        showRegister
          ? <Register token={ token } creationUrl={ creationUrl } />
          : null
      }
    </>
  );
}
